import Vue from "vue";
import app from "./app.vue";
import router from "@/router/index.js";

import Filters from "@/filters/index.js";
import { removeCookies } from "@/util";
import { GlobalMixins } from "@/mixins";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faUser, faPause, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// general NPM
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import BootstrapVue from "bootstrap-vue";
import vSelect from "vue-select";
import axios from "axios";
import VueAxios from "vue-axios";
import VueQuillEditor from "vue-quill-editor";

// directives (.js files can't be dynamically imported)
import MaxEllipsis from "@/directives/max-ellipsis.js";
import SortTable from "@/directives/sort-table.js";
import AddActive from "@/directives/add-active.js";

// general CSS/SASS
import "vue-select/dist/vue-select.css";
import "@/scss/app.scss";
import "quill/dist/quill.snow.css";

Object.keys(Filters).forEach((key) => Vue.filter(key, Filters[key]));

Vue.use(VueQuillEditor, { theme: "snow" });
// directives
Vue.directive("max-ellipsis", MaxEllipsis);
Vue.directive("sort-table", SortTable);
Vue.directive("add-active", AddActive);

Vue.component(
  "assessment-card",
  () => import("@/components/cards/assessment.vue"),
);
Vue.component("upload-card", () => import("@/components/cards/upload.vue"));
Vue.component("template-card", () => import("@/components/cards/template.vue"));
Vue.component("category-card", () => import("@/components/cards/category.vue"));
Vue.component("question-card", () => import("@/components/cards/question.vue"));
Vue.component("selector-card", () => import("@/components/cards/selector.vue"));

// misc components
Vue.component("svg-loader", () => import("@/components/misc/svg-loader.vue"));
Vue.component("no-results", () => import("@/components/misc/no-results.vue"));
Vue.component(
  "loading-wrap",
  () => import("@/components/misc/loading-wrap.vue"),
);
Vue.component(
  "result-pagination",
  () => import("@/components/misc/result-pagination.vue"),
);
Vue.component(
  "custom-search",
  () => import("@/components/misc/custom-search.vue"),
);
Vue.component(
  "data-display",
  () => import("@/components/misc/data-display.vue"),
);
Vue.component("help-tip", () => import("@/components/misc/help-tip.vue"));
Vue.component("array-input", () => import("@/components/misc/array-input.vue")); //@TODO, check if still used
Vue.component(
  "array-select",
  () => import("@/components/misc/array-select.vue"),
); //@TODO, check if still used
Vue.component(
  "preference-select",
  () => import("@/components/misc/preference-select.vue"),
);
Vue.component("icon-header", () => import("@/components/misc/icon-header.vue"));

//table helpers
Vue.component(
  "export-section",
  () => import("@/components/table-helpers/export-section.vue"),
);
Vue.component(
  "filter-results",
  () => import("@/components/table-helpers/filter-results.vue"),
);

//badges
Vue.component("boolean-badge", () => import("@/components/badges/boolean.vue"));
Vue.component("key-badges", () => import("@/components/badges/keys.vue"));

// npm
Vue.component("v-select", vSelect);

let baseURL;

if (location.port === "8080" || location.port === "3001" || location.hostname === "localhost") {
  // Let's assume we're on the private network if our port is 8080 or 3001
  baseURL = `${location.protocol}//${location.hostname}:9001`;
} else {
  baseURL = location.origin;
}

Vue.use(BootstrapVue);
library.add(faUser, faPause, faCheck);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VueAxios, axios);

Vue.axios.defaults.withCredentials = true;
Vue.axios.defaults.baseURL = baseURL;
Vue.axios.interceptors.response.use(
  (response) => {
    //@TODO, we might be able to replace this function with undefined?

    //Pass along non-caught responses
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      //@TODO, do we need to reject the promise in this block too?
      removeCookies();
      return (location.href = "/?sessionExpired=1");
    }

    return Promise.reject(error);
  },
);

// Global Mixins
Vue.mixin({
  methods: GlobalMixins,
});

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(app),
}).$mount("#app");
